/* =====================================================================
   La corona y el diamante · DIRECTRIZ-LOOP L1-3 (R-PLAN2)
   =====================================================================
   Dibujo propio, sin librería de iconos, y distinguidos POR FORMA y no
   por color: una corona tiene tres puntas y base recta; un diamante es
   un rombo con facetas. Quien no distingue colores los distingue igual,
   y quien lee con un lector de pantalla oye la palabra, no «icono».
   El candado es para el tercer caso —apagado sin catálogo— y también se
   dice con palabra.
   ===================================================================== */
const TITULOS = {
  corona: 'Incluido en un plan superior',
  diamante: 'Se cotiza aparte',
  candado: 'No está encendido en tu cuenta',
};

export function Corona({ className = 'h-4 w-4' }) {
  return (
    <svg viewBox="0 0 20 20" className={className} aria-hidden="true" focusable="false">
      <path d="M2.5 15.5h15v2h-15z" fill="currentColor" />
      <path d="M2.5 14 3.6 5.8l4.1 3.6L10 3.5l2.3 5.9 4.1-3.6L17.5 14z"
            fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinejoin="round" />
    </svg>
  );
}

export function Diamante({ className = 'h-4 w-4' }) {
  return (
    <svg viewBox="0 0 20 20" className={className} aria-hidden="true" focusable="false">
      <path d="M5 3.5h10l3.5 5L10 17.5 1.5 8.5z"
            fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinejoin="round" />
      <path d="M1.5 8.5h17M5 3.5l2.5 5 2.5-5 2.5 5 2.5-5M7.5 8.5 10 17.5l2.5-9"
            fill="none" stroke="currentColor" strokeWidth="1" strokeLinejoin="round" />
    </svg>
  );
}

export function Candado({ className = 'h-4 w-4' }) {
  return (
    <svg viewBox="0 0 20 20" className={className} aria-hidden="true" focusable="false">
      <rect x="4" y="8.5" width="12" height="9" rx="1.5" fill="none" stroke="currentColor" strokeWidth="1.6" />
      <path d="M6.5 8.5V6a3.5 3.5 0 0 1 7 0v2.5" fill="none" stroke="currentColor" strokeWidth="1.6" />
    </svg>
  );
}

/** La marca con su palabra al lado (nunca el dibujo solo: criterio 2). */
export default function MarcaDePlan({ marca, conPalabra = true, className = 'h-4 w-4' }) {
  const Dibujo = marca === 'corona' ? Corona : marca === 'diamante' ? Diamante : Candado;
  const titulo = TITULOS[marca] || TITULOS.candado;
  return (
    <span className="inline-flex items-center gap-1 text-[var(--color-marca)]" title={titulo}>
      <Dibujo className={className} />
      {conPalabra && <span className="text-[11px] font-semibold uppercase tracking-wide">{
        marca === 'corona' ? 'Plan' : marca === 'diamante' ? 'Cotizar' : 'Apagado'
      }</span>}
      <span className="sr-only">{titulo}</span>
    </span>
  );
}
